export async function activateVerifiedAgentProfile(user, profile = {}) {
  return profile;
}
